// extracted by mini-css-extract-plugin
export default {"section":"launch_section__5FJk0","slogans":"launch_slogans__B8rHZ","slogan":"launch_slogan__AhKnA"};